import React, { useEffect, useState, useContext } from "react";
import * as S from "./ClientsStyle";
import { formatCPF, formatDateClients } from "../ASSETS/assets";
import { AuthContext } from "../../Context/AuthContext";
import Loading from "../Loader";
import PaginaCliente from "../PaginaDoCliente/PaginaCliente";
import CreateClientModal from "./CreateClientModal/CreateClientModal";
import { FaPlus, FaSearch } from "react-icons/fa";
import { useMessage } from "../../Context/MessageContext";
import { auditService } from "../../Services/auditService"; // <<< 1. IMPORTE O SERVIÇO DE AUDITORIA
import { useNavigate } from "react-router-dom";

export default function Clients() {
  const { getClients, clientsDataBase, totalClients, totalClientsWithMoney, authState } =
    useContext(AuthContext);
  const [search, setSearch] = useState("");
  const [orderFilter, setOrderFilter] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [load, setLoad] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [isCreateModalOpen, setCreateModalOpen] = useState(false);
  const { showMessage } = useMessage();
  const totalPages = Math.ceil(totalClients / itemsPerPage);
  const navigate = useNavigate();

  useEffect(() => {
    if(authState && authState.viewPermissions && !authState.viewPermissions.client){
      navigate("/")
    }
    console.log(authState.viewPermissions.client)

  }, [authState])

  const fetchClients = async (page) => {
    setLoad(true);
    const offset = (page - 1) * itemsPerPage;
    try {
      await getClients(itemsPerPage, offset, search, orderFilter, "");
    } catch (e) {
      console.error("Erro ao buscar clientes:", e);
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    fetchClients(currentPage);
  }, [currentPage, orderFilter]);

  const handleSearch = () => {
    setCurrentPage(1);
    fetchClients(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  // <<< 2. CRIE A NOVA FUNÇÃO DE CLICK
  const handleClientClick = async (client) => {
    setSelectedClient(client);
    await auditService.registerAdminClientAccess(client.id, client.name);
  };

  return (
    <>
      {selectedClient && (
        <PaginaCliente
          fetchClients={() => fetchClients(currentPage)}
          handleClose={() => setSelectedClient(null)}
          clienteData={selectedClient}
        />
      )}
      {isCreateModalOpen && (
        <CreateClientModal
          handleClose={() => setCreateModalOpen(false)}
          onClientCreated={() => {
            setCreateModalOpen(false);
            fetchClients(1);
          }}
        />
      )}

      <Loading load={load} />
      <S.PageContainer>
        <S.StatsGrid>
          <S.StatCard>
            <h4>Clientes na Plataforma</h4>
            <span>{totalClients}</span>
          </S.StatCard>
          <S.StatCard>
            <h4>Clientes com Contratos Ativos</h4>
            <span>{totalClientsWithMoney}</span>
          </S.StatCard>
        </S.StatsGrid>

        <S.ContentBox>
          <S.Header>
            <h2>Clientes</h2>
            <S.ActionButton onClick={() => setCreateModalOpen(true)}>
              <FaPlus /> Adicionar Cliente
            </S.ActionButton>
          </S.Header>

          <S.FilterArea>
            <S.SearchBar>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                type="text"
                placeholder="Pesquisar por nome ou CPF..."
              />
              <button onClick={handleSearch}>
                <FaSearch />
              </button>
            </S.SearchBar>
            <S.FilterGroup>
              <label>Ordenar por:</label>
              <select
                value={orderFilter}
                onChange={(e) => setOrderFilter(e.target.value)}
              >
                <option value="desc">Mais Recentes</option>
                <option value="asc">Mais Antigos</option>
              </select>
            </S.FilterGroup>
          </S.FilterArea>

          <S.TableContainer>
            <S.Table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Data Cad.</th>
                  <th>Nome</th>
                  <th>CPF/CNPJ</th>
                  <th>E-mail</th>
                  <th>Celular</th>
                  <th>Total Investido</th>
                </tr>
              </thead>
              <tbody>
                {clientsDataBase.length > 0 ? (
                  clientsDataBase.map((client) => (
                    // <<< 3. ATUALIZE O ONCLICK PARA USAR A NOVA FUNÇÃO
                    <tr
                      onClick={() => handleClientClick(client)}
                      key={client.id}
                    >
                      <td>#{client.id}</td>
                      <td>{formatDateClients(client.dateCreated)}</td>
                      <td>{client.name}</td>
                      <td>{formatCPF(client.cpfCnpj)}</td>
                      <td>{client.email}</td>
                      <td>{client.phone_number || "N/A"}</td>
                      <td>R$ 0,00</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">Nenhum cliente encontrado.</td>
                  </tr>
                )}
              </tbody>
            </S.Table>
          </S.TableContainer>

          <S.PaginationContainer>
            <S.PaginationButton
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Anterior
            </S.PaginationButton>
            <span>
              Página {currentPage} de {totalPages}
            </span>
            <S.PaginationButton
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Próxima
            </S.PaginationButton>
          </S.PaginationContainer>
        </S.ContentBox>
      </S.PageContainer>
    </>
  );
}
